import React, { Component } from "react";
import { css } from "aphrodite";
import { styles } from "./ForgotPasswordStyles";

import { connect } from "react-redux";
import { passwordActions } from "../_actions";
import Header from "../components/Header";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
  }

  submit = values => {
    this.props.dispatch(passwordActions.sendRecoveryEmail(values.email));
  };

  render() {
    return (
      <div>
        <Header
          title={"Password Recovery"}
          loggedOut={true}
          backTitle={"Login"}
          backHref={"/"}
          hideAccount={true}
        />
        <div className={css(styles.background)}>
          <div className={css(styles.wrapper)}>
            <ForgotPasswordForm onSubmit={this.submit} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(ForgotPassword);

// const connectedLoginPage = connect(mapStateToProps)(LoginPage);
// export { connectedLoginPage as LoginPage };
